import { z } from 'zod';

import { OrganizationIdParamsSchema } from '../organizations/get-organization.schemas.js';

export const OrganizationPlaceParamsSchema = OrganizationIdParamsSchema.extend({
  placeId: z.uuid(),
});

export type OrganizationPlaceParams = z.infer<typeof OrganizationPlaceParamsSchema>;

export const DeactivatePlaceBodySchema = z.object({
  confirmLastActivePlace: z.boolean(),
});

export type DeactivatePlaceBody = z.infer<typeof DeactivatePlaceBodySchema>;

export const DeactivatePlaceResponseSchema = z.object({
  placeId: z.uuid(),
  active: z.literal(false),
});

export type DeactivatePlaceResponse = z.infer<typeof DeactivatePlaceResponseSchema>;
